import { AspectRatioRounded, Search, QuestionMarkRounded } from '@mui/icons-material';
import { FilledInput, FormControl, Grid, IconButton, InputAdornment, InputLabel } from '@mui/material';
import useAspectRatio from '../../../../hooks/useAspectRatio';
import { useDispatch, useSelector } from 'react-redux';
import styles from '../SearchBox/styles';
import { useState } from 'react';
import { REDUX_ACTIONS } from '../../../../shared/config/constants';
import { listPayTargets } from '../../../../store/actions/payTargets';
import PayTargetsQuestionsDialog from '../../PayTargets/PayTargetsQuestionsModal';

const PayTargetControls = () => {
  const classes = styles();
  const dispatch = useDispatch();
  const { preferences } = useSelector((state) => state.currentUser);
  const payTargets = useSelector((state) => state.payTargets);
  const [searchKey, setSearchKey] = useState('');
  const [payTargetQuestionsDialog, setPayTargetQuestionsDialog] = useState(false);

  const handleAspectRatio = useAspectRatio();

  const handleOnChange = (e) => {
    setSearchKey(e.target.value);
  };

  const handleSearch = (value) => {
    dispatch({
      type: REDUX_ACTIONS.PAY_TARGETS_SEARCH_CHANGE,
      payload: value
    });
    dispatch(listPayTargets(searchKey));
  };

  const handleEnter = (e) => {
    if (e.key === 'Enter') {
      handleSearch(searchKey);
    }
  };

  return (
        <Grid display='flex' alignItems="center" marginLeft='auto'>
            <FormControl>
                <InputLabel
                    htmlFor="outlined-adornment-search"
                    inputprops={{ classes: { root: classes.searchBar } }}
                >
                    Search
                </InputLabel>
                <FilledInput
                    className={classes.searchBar}
                    id="outlined-adornment-search"
                    type="text"
                    label="Search"
                    value={searchKey}
                    onChange={handleOnChange}
                    onKeyDown={handleEnter}
                    disabled={payTargets?.loading}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                edge="end"
                                onClick={() => handleSearch(searchKey)}
                            >
                                <Search />
                            </IconButton>
                        </InputAdornment>
                    }
                />
            </FormControl>
            <IconButton
                onClick={() => {
                  setPayTargetQuestionsDialog(true);
                }}
                disabled={payTargets?.loading}
            >
                <QuestionMarkRounded />
            </IconButton>
            <IconButton
                edge="end"
                onClick={() => {
                  handleAspectRatio(!preferences.aspectChanged);
                }}
                disabled={payTargets?.loading}
            >
                <AspectRatioRounded />
            </IconButton>
            {payTargetQuestionsDialog
              ? (
              <PayTargetsQuestionsDialog
                isOpen={payTargetQuestionsDialog}
                onCloseClick={() => setPayTargetQuestionsDialog(false)}
              />
                )
              : null}
        </Grid>
  );
};

export default PayTargetControls;
